var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("v-app", { attrs: { id: "inspire" } }, [
    _vm.isAzureDeployed == 1
      ? _c(
          "div",
          [
            _c(
              "oauth-wrapper",
              {
                attrs: {
                  authorizeUrl: _vm.authorizeUrl,
                  tokenUrl: _vm.tokenUrl,
                  logoutUrl: _vm.logoutUrl,
                  scope: _vm.scope,
                  client_id: _vm.client_id,
                  redirect_uri: _vm.redirect_uri,
                  resource: _vm.resource,
                  autoLogin: _vm.autoLogin,
                  loginIncrementor: _vm.loginIncrementor,
                  showDebugInfo: _vm.showDebugInfo
                },
                on: { "logged-in": _vm.credentialschanged }
              },
              [
                _vm.loginComplete
                  ? _c("div", [
                      _vm.user != null &&
                      _vm.user.userEmail != null &&
                      _vm.user.id != -1
                        ? _c(
                            "div",
                            [
                              _c(
                                "v-navigation-drawer",
                                {
                                  attrs: {
                                    dark: "",
                                    src:
                                      "https://www.lyondellbasell.com/globalassets/news-events/media-kit/lyondellbasell-mediaimages-refinery-loc_pla_1145_0.jpg?id=8566",
                                    app: ""
                                  },
                                  model: {
                                    value: _vm.drawer,
                                    callback: function($$v) {
                                      _vm.drawer = $$v
                                    },
                                    expression: "drawer"
                                  }
                                },
                                [
                                  _c(
                                    "v-toolbar",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.isLoggedInUserActive,
                                          expression: "isLoggedInUserActive"
                                        }
                                      ],
                                      attrs: { color: "primary" }
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticStyle: { "text-align": "right" }
                                        },
                                        [
                                          _c(
                                            "v-avatar",
                                            {
                                              attrs: {
                                                color: "primary",
                                                small: ""
                                              }
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  directives: [
                                                    {
                                                      name: "show",
                                                      rawName: "v-show",
                                                      value:
                                                        _vm.profilePic == "",
                                                      expression:
                                                        "profilePic == ''"
                                                    }
                                                  ],
                                                  attrs: { dark: "", large: "" }
                                                },
                                                [_vm._v("account_circle")]
                                              ),
                                              _vm._v(" "),
                                              _c("img", {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value: _vm.profilePic != "",
                                                    expression:
                                                      "profilePic != ''"
                                                  }
                                                ],
                                                attrs: {
                                                  src: _vm.profilePic,
                                                  alt: "Base64 encoded image"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c("span", [
                                            _vm._v(_vm._s(_vm.user.userName))
                                          ])
                                        ],
                                        1
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-card",
                                    [
                                      _c(
                                        "v-list",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: _vm.isLoggedInUserActive,
                                              expression: "isLoggedInUserActive"
                                            }
                                          ],
                                          attrs: { nav: "", dense: "" }
                                        },
                                        [
                                          _vm._l(_vm.items, function(item, i) {
                                            return _c(
                                              "v-list-item",
                                              {
                                                key: i,
                                                attrs: {
                                                  link: "",
                                                  to: item.link
                                                }
                                              },
                                              [
                                                _c(
                                                  "v-list-item-action",
                                                  [
                                                    _c("v-icon", [
                                                      _vm._v(_vm._s(item.icon))
                                                    ])
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "v-list-item-content",
                                                  [
                                                    _c("v-list-item-title", [
                                                      _vm._v(
                                                        _vm._s(_vm.$t("home"))
                                                      )
                                                    ])
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "v-list-group",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value:
                                                    _vm.hasAdminAccess &&
                                                    !_vm.hasGlobalAccess,
                                                  expression:
                                                    "hasAdminAccess && !hasGlobalAccess"
                                                }
                                              ],
                                              attrs: {
                                                "prepend-icon": "settings",
                                                value: "true"
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "activator",
                                                    fn: function() {
                                                      return [
                                                        _c(
                                                          "v-list-item-title",
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t("admin")
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    },
                                                    proxy: true
                                                  }
                                                ],
                                                null,
                                                false,
                                                4012197972
                                              )
                                            },
                                            [
                                              _vm._v(" "),
                                              _vm._l(_vm.admin2, function(
                                                admin,
                                                i
                                              ) {
                                                return _c(
                                                  "v-list-item",
                                                  {
                                                    key: i,
                                                    attrs: {
                                                      link: "",
                                                      to: admin.link
                                                    }
                                                  },
                                                  [
                                                    admin.text == "Users"
                                                      ? _c(
                                                          "v-list-item-title",
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t("users")
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    admin.text ==
                                                    "Plant Specific Data"
                                                      ? _c(
                                                          "v-list-item-title",
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "plantspecificdata"
                                                                )
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    admin.text == "Feedback"
                                                      ? _c(
                                                          "v-list-item-title",
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "feedback"
                                                                )
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _c(
                                                      "v-list-item-icon",
                                                      [
                                                        _c("v-icon", [
                                                          _vm._v(
                                                            _vm._s(admin.icon)
                                                          )
                                                        ])
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                )
                                              })
                                            ],
                                            2
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-list-group",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value: _vm.hasGlobalAccess,
                                                  expression: "hasGlobalAccess"
                                                }
                                              ],
                                              attrs: {
                                                "prepend-icon": "settings",
                                                value: "true"
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "activator",
                                                    fn: function() {
                                                      return [
                                                        _c(
                                                          "v-list-item-title",
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t("admin")
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    },
                                                    proxy: true
                                                  }
                                                ],
                                                null,
                                                false,
                                                4012197972
                                              )
                                            },
                                            [
                                              _vm._v(" "),
                                              _vm._l(_vm.admins, function(
                                                admin,
                                                i
                                              ) {
                                                return _c(
                                                  "v-list-item",
                                                  {
                                                    key: i,
                                                    attrs: {
                                                      link: "",
                                                      to: admin.link
                                                    }
                                                  },
                                                  [
                                                    admin.text == "Users"
                                                      ? _c(
                                                          "v-list-item-title",
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t("users")
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    admin.text == "Plants"
                                                      ? _c(
                                                          "v-list-item-title",
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t("plants")
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    admin.text ==
                                                    "Plant Specific Data"
                                                      ? _c(
                                                          "v-list-item-title",
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "plantspecificdata"
                                                                )
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    admin.text == "Feedback"
                                                      ? _c(
                                                          "v-list-item-title",
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "feedback"
                                                                )
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    admin.text == "Languages"
                                                      ? _c(
                                                          "v-list-item-title",
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "languages"
                                                                )
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _c(
                                                      "v-list-item-icon",
                                                      [
                                                        _c("v-icon", [
                                                          _vm._v(
                                                            _vm._s(admin.icon)
                                                          )
                                                        ])
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                )
                                              })
                                            ],
                                            2
                                          )
                                        ],
                                        2
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-app-bar",
                                {
                                  attrs: { app: "", color: "primary", dark: "" }
                                },
                                [
                                  _c("v-app-bar-nav-icon", {
                                    on: {
                                      click: function($event) {
                                        $event.stopPropagation()
                                        _vm.drawer = !_vm.drawer
                                      }
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("v-toolbar-title", [
                                    _vm._v(_vm._s(_vm.$t("title")))
                                  ]),
                                  _vm._v(" "),
                                  _c("v-spacer"),
                                  _vm._v(" "),
                                  _c("v-spacer"),
                                  _vm._v(" "),
                                  _c("v-spacer", [
                                    _c(
                                      "div",
                                      {
                                        staticStyle: { "text-align": "right" }
                                      },
                                      [
                                        _c(
                                          "v-tooltip",
                                          {
                                            attrs: { bottom: "" },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "activator",
                                                  fn: function(ref) {
                                                    var on = ref.on
                                                    var attrs = ref.attrs
                                                    return [
                                                      _c(
                                                        "v-icon",
                                                        _vm._g(
                                                          _vm._b(
                                                            {
                                                              directives: [
                                                                {
                                                                  name: "show",
                                                                  rawName:
                                                                    "v-show",
                                                                  value:
                                                                    _vm.isLoggedInUserActive &&
                                                                    _vm.isNonLYBUser,
                                                                  expression:
                                                                    "isLoggedInUserActive && isNonLYBUser"
                                                                }
                                                              ],
                                                              attrs: {
                                                                dark: ""
                                                              },
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  $event.stopPropagation()
                                                                  _vm.fbdialog = true
                                                                }
                                                              }
                                                            },
                                                            "v-icon",
                                                            attrs,
                                                            false
                                                          ),
                                                          on
                                                        ),
                                                        [_vm._v("feedback")]
                                                      ),
                                                      _vm._v(" "),
                                                      _vm._v(
                                                        "\n                                          \n                                        "
                                                      ),
                                                      _c(
                                                        "v-dialog",
                                                        {
                                                          attrs: {
                                                            "max-width": "70%"
                                                          },
                                                          model: {
                                                            value: _vm.fbdialog,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.fbdialog = $$v
                                                            },
                                                            expression:
                                                              "fbdialog"
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "v-card",
                                                            [
                                                              _c(
                                                                "v-card-title",
                                                                [
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "headline"
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          _vm.$t(
                                                                            "feedback"
                                                                          )
                                                                        )
                                                                      )
                                                                    ]
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "v-spacer"
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "v-icon",
                                                                    {
                                                                      on: {
                                                                        click: function(
                                                                          $event
                                                                        ) {
                                                                          _vm.fbdialog = false
                                                                          _vm.$toast.clear()
                                                                        }
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "close"
                                                                      )
                                                                    ]
                                                                  )
                                                                ],
                                                                1
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "v-card-text",
                                                                [
                                                                  _c(
                                                                    "v-container",
                                                                    [
                                                                      _c(
                                                                        "v-textarea",
                                                                        {
                                                                          attrs: {
                                                                            outlined:
                                                                              "",
                                                                            label: _vm.$t(
                                                                              "feedback"
                                                                            )
                                                                          },
                                                                          model: {
                                                                            value:
                                                                              _vm
                                                                                .feedbackItem
                                                                                .comments,
                                                                            callback: function(
                                                                              $$v
                                                                            ) {
                                                                              _vm.$set(
                                                                                _vm.feedbackItem,
                                                                                "comments",
                                                                                $$v
                                                                              )
                                                                            },
                                                                            expression:
                                                                              "feedbackItem.comments"
                                                                          }
                                                                        }
                                                                      )
                                                                    ],
                                                                    1
                                                                  )
                                                                ],
                                                                1
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "v-card-actions",
                                                                [
                                                                  _c(
                                                                    "v-btn",
                                                                    {
                                                                      attrs: {
                                                                        color:
                                                                          "blue darken-1",
                                                                        text: ""
                                                                      },
                                                                      on: {
                                                                        click: function(
                                                                          $event
                                                                        ) {
                                                                          _vm.fbdialog = false
                                                                          _vm.$toast.clear()
                                                                        }
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          _vm.$t(
                                                                            "cancel"
                                                                          )
                                                                        )
                                                                      )
                                                                    ]
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "v-spacer"
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "v-btn",
                                                                    {
                                                                      staticClass:
                                                                        "mb-2",
                                                                      attrs: {
                                                                        color:
                                                                          "primary",
                                                                        dark: ""
                                                                      },
                                                                      on: {
                                                                        click:
                                                                          _vm.fbsave
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          _vm.$t(
                                                                            "save"
                                                                          )
                                                                        )
                                                                      )
                                                                    ]
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ]
                                                  }
                                                }
                                              ],
                                              null,
                                              false,
                                              3819939783
                                            )
                                          },
                                          [
                                            _vm._v(" "),
                                            _c("span", [_vm._v("Feedback")])
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-btn",
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value: _vm.isLoggedInUserActive,
                                                expression:
                                                  "isLoggedInUserActive"
                                              }
                                            ],
                                            attrs: { icon: "", color: "white" },
                                            on: {
                                              click: function($event) {
                                                $event.stopPropagation()
                                                return _vm.openUserPreference()
                                              }
                                            }
                                          },
                                          [_c("v-icon", [_vm._v("settings")])],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-dialog",
                                          {
                                            attrs: {
                                              persistent: "",
                                              "max-width": "600px"
                                            },
                                            model: {
                                              value: _vm.dialog,
                                              callback: function($$v) {
                                                _vm.dialog = $$v
                                              },
                                              expression: "dialog"
                                            }
                                          },
                                          [
                                            _c(
                                              "v-card",
                                              [
                                                _c(
                                                  "v-card-title",
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass: "headline"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "userprofile"
                                                            )
                                                          )
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c("v-spacer"),
                                                    _vm._v(" "),
                                                    _c(
                                                      "v-icon",
                                                      {
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            _vm.dialog = false
                                                          }
                                                        }
                                                      },
                                                      [_vm._v("close")]
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "v-card-text",
                                                  [
                                                    _c(
                                                      "v-container",
                                                      [
                                                        _c(
                                                          "v-row",
                                                          [
                                                            _c(
                                                              "v-col",
                                                              {
                                                                attrs: {
                                                                  cols: "12",
                                                                  sm: "8",
                                                                  md: "8"
                                                                }
                                                              },
                                                              [
                                                                _c("v-select", {
                                                                  attrs: {
                                                                    items:
                                                                      _vm.languages,
                                                                    label: _vm.$t(
                                                                      "selectlanguage"
                                                                    ),
                                                                    "item-text":
                                                                      "language",
                                                                    "item-value":
                                                                      "id",
                                                                    required: ""
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      _vm.selectedlanguage,
                                                                    callback: function(
                                                                      $$v
                                                                    ) {
                                                                      _vm.selectedlanguage = $$v
                                                                    },
                                                                    expression:
                                                                      "selectedlanguage"
                                                                  }
                                                                })
                                                              ],
                                                              1
                                                            )
                                                          ],
                                                          1
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "v-row",
                                                          [
                                                            _c(
                                                              "v-col",
                                                              {
                                                                attrs: {
                                                                  cols: "12",
                                                                  sm: "8",
                                                                  md: "8"
                                                                }
                                                              },
                                                              [
                                                                _c("v-select", {
                                                                  attrs: {
                                                                    items:
                                                                      _vm.itemsddlDateFormat,
                                                                    label: _vm.$t(
                                                                      "selectdateformat"
                                                                    ),
                                                                    "item-text":
                                                                      "DateFormat",
                                                                    required: ""
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      _vm.selectedDateFormat,
                                                                    callback: function(
                                                                      $$v
                                                                    ) {
                                                                      _vm.selectedDateFormat = $$v
                                                                    },
                                                                    expression:
                                                                      "selectedDateFormat"
                                                                  }
                                                                })
                                                              ],
                                                              1
                                                            )
                                                          ],
                                                          1
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "v-row",
                                                          [
                                                            _c(
                                                              "v-col",
                                                              {
                                                                attrs: {
                                                                  cols: "12",
                                                                  sm: "8",
                                                                  md: "8"
                                                                }
                                                              },
                                                              [
                                                                _c("v-select", {
                                                                  attrs: {
                                                                    items:
                                                                      _vm.itemsRowsPerPage,
                                                                    label: _vm.$t(
                                                                      "rowsperpage"
                                                                    ),
                                                                    required: ""
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      _vm.selectedRowsPerPage,
                                                                    callback: function(
                                                                      $$v
                                                                    ) {
                                                                      _vm.selectedRowsPerPage = $$v
                                                                    },
                                                                    expression:
                                                                      "selectedRowsPerPage"
                                                                  }
                                                                })
                                                              ],
                                                              1
                                                            )
                                                          ],
                                                          1
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "v-row",
                                                          {
                                                            directives: [
                                                              {
                                                                name: "show",
                                                                rawName:
                                                                  "v-show",
                                                                value:
                                                                  _vm.isLoggedInUserActive &&
                                                                  _vm.isNonLYBUser &&
                                                                  _vm.isUserInOnePlant,
                                                                expression:
                                                                  "\n                      isLoggedInUserActive && isNonLYBUser && isUserInOnePlant\n                    "
                                                              }
                                                            ]
                                                          },
                                                          [
                                                            _c(
                                                              "v-col",
                                                              {
                                                                attrs: {
                                                                  cols: "12",
                                                                  sm: "8",
                                                                  md: "8"
                                                                }
                                                              },
                                                              [
                                                                _c("v-select", {
                                                                  attrs: {
                                                                    items:
                                                                      _vm.allRelatedMGs,
                                                                    label:
                                                                      "Select Maintenance Group",
                                                                    "item-text":
                                                                      "value",
                                                                    "item-value":
                                                                      "id"
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      _vm.selectedMaintenanceGroup,
                                                                    callback: function(
                                                                      $$v
                                                                    ) {
                                                                      _vm.selectedMaintenanceGroup = $$v
                                                                    },
                                                                    expression:
                                                                      "selectedMaintenanceGroup"
                                                                  }
                                                                })
                                                              ],
                                                              1
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "v-card-actions",
                                                  [
                                                    _c(
                                                      "v-btn",
                                                      {
                                                        attrs: {
                                                          color:
                                                            "blue darken-1",
                                                          text: ""
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            _vm.dialog = false
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t("close")
                                                          )
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c("v-spacer"),
                                                    _vm._v(" "),
                                                    _c("v-spacer"),
                                                    _vm._v(" "),
                                                    _c(
                                                      "v-btn",
                                                      {
                                                        attrs: {
                                                          color: "primary"
                                                        },
                                                        on: {
                                                          click: _vm.saveProfile
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(_vm.$t("save"))
                                                        )
                                                      ]
                                                    )
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ])
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-main",
                                [
                                  _c(
                                    "v-container",
                                    { attrs: { fluid: "" } },
                                    [
                                      _c(
                                        "v-row",
                                        {
                                          attrs: {
                                            align: "start",
                                            justify: "center"
                                          }
                                        },
                                        [
                                          _c(
                                            "v-col",
                                            { staticClass: "text-center" },
                                            [_c("router-view")],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-footer",
                                { attrs: { color: "primary", app: "" } },
                                [
                                  _c("span", { staticClass: "white--text" }, [
                                    _vm._v(
                                      "© " + _vm._s(new Date().getFullYear())
                                    )
                                  ])
                                ]
                              )
                            ],
                            1
                          )
                        : _c("div", [
                            _c(
                              "div",
                              { staticClass: "center-screen" },
                              [
                                _c("v-progress-circular", {
                                  attrs: {
                                    size: 70,
                                    width: 7,
                                    color: "purple",
                                    indeterminate: ""
                                  }
                                })
                              ],
                              1
                            )
                          ])
                    ])
                  : _c("div", [
                      _c(
                        "div",
                        { staticClass: "center-screen" },
                        [
                          _c("v-progress-circular", {
                            attrs: {
                              size: 70,
                              width: 7,
                              color: "purple",
                              indeterminate: ""
                            }
                          })
                        ],
                        1
                      )
                    ])
              ]
            )
          ],
          1
        )
      : _c("div", [
          _vm.user != null && _vm.user.userEmail != null && _vm.user.id != -1
            ? _c(
                "div",
                [
                  _c(
                    "v-navigation-drawer",
                    {
                      attrs: {
                        dark: "",
                        src:
                          "https://www.lyondellbasell.com/globalassets/news-events/media-kit/lyondellbasell-mediaimages-refinery-loc_pla_1145_0.jpg?id=8566",
                        app: ""
                      },
                      model: {
                        value: _vm.drawer,
                        callback: function($$v) {
                          _vm.drawer = $$v
                        },
                        expression: "drawer"
                      }
                    },
                    [
                      _c(
                        "v-toolbar",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.isLoggedInUserActive,
                              expression: "isLoggedInUserActive"
                            }
                          ],
                          attrs: { color: "primary" }
                        },
                        [
                          _c(
                            "div",
                            { staticStyle: { "text-align": "right" } },
                            [
                              _c(
                                "v-avatar",
                                { attrs: { color: "primary", small: "" } },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.profilePic == "",
                                          expression: "profilePic == ''"
                                        }
                                      ],
                                      attrs: { dark: "", large: "" }
                                    },
                                    [_vm._v("account_circle")]
                                  ),
                                  _vm._v(" "),
                                  _c("img", {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.profilePic != "",
                                        expression: "profilePic != ''"
                                      }
                                    ],
                                    attrs: {
                                      src: _vm.profilePic,
                                      alt: "Base64 encoded image"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("span", [_vm._v(_vm._s(_vm.user.userName))])
                            ],
                            1
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-card",
                        [
                          _c(
                            "v-list",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.isLoggedInUserActive,
                                  expression: "isLoggedInUserActive"
                                }
                              ],
                              attrs: { nav: "", dense: "" }
                            },
                            [
                              _vm._l(_vm.items, function(item, i) {
                                return _c(
                                  "v-list-item",
                                  {
                                    key: i,
                                    attrs: { link: "", to: item.link }
                                  },
                                  [
                                    _c(
                                      "v-list-item-action",
                                      [
                                        _c("v-icon", [
                                          _vm._v(_vm._s(item.icon))
                                        ])
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-list-item-content",
                                      [
                                        _c("v-list-item-title", [
                                          _vm._v(_vm._s(_vm.$t("home")))
                                        ])
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              }),
                              _vm._v(" "),
                              _c(
                                "v-list-group",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value:
                                        _vm.hasAdminAccess &&
                                        !_vm.hasGlobalAccess,
                                      expression:
                                        "hasAdminAccess && !hasGlobalAccess"
                                    }
                                  ],
                                  attrs: {
                                    "prepend-icon": "settings",
                                    value: "true"
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function() {
                                          return [
                                            _c("v-list-item-title", [
                                              _vm._v(_vm._s(_vm.$t("admin")))
                                            ])
                                          ]
                                        },
                                        proxy: true
                                      }
                                    ],
                                    null,
                                    false,
                                    4012197972
                                  )
                                },
                                [
                                  _vm._v(" "),
                                  _vm._l(_vm.admin2, function(admin, i) {
                                    return _c(
                                      "v-list-item",
                                      {
                                        key: i,
                                        attrs: { link: "", to: admin.link }
                                      },
                                      [
                                        admin.text == "Users"
                                          ? _c("v-list-item-title", [
                                              _vm._v(_vm._s(_vm.$t("users")))
                                            ])
                                          : _vm._e(),
                                        _vm._v(" "),
                                        admin.text == "Plant Specific Data"
                                          ? _c("v-list-item-title", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("plantspecificdata")
                                                )
                                              )
                                            ])
                                          : _vm._e(),
                                        _vm._v(" "),
                                        admin.text == "Feedback"
                                          ? _c("v-list-item-title", [
                                              _vm._v(_vm._s(_vm.$t("feedback")))
                                            ])
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c(
                                          "v-list-item-icon",
                                          [
                                            _c("v-icon", [
                                              _vm._v(_vm._s(admin.icon))
                                            ])
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  })
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _c(
                                "v-list-group",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.hasGlobalAccess,
                                      expression: "hasGlobalAccess"
                                    }
                                  ],
                                  attrs: {
                                    "prepend-icon": "settings",
                                    value: "true"
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function() {
                                          return [
                                            _c("v-list-item-title", [
                                              _vm._v(_vm._s(_vm.$t("admin")))
                                            ])
                                          ]
                                        },
                                        proxy: true
                                      }
                                    ],
                                    null,
                                    false,
                                    4012197972
                                  )
                                },
                                [
                                  _vm._v(" "),
                                  _vm._l(_vm.admins, function(admin, i) {
                                    return _c(
                                      "v-list-item",
                                      {
                                        key: i,
                                        attrs: { link: "", to: admin.link }
                                      },
                                      [
                                        admin.text == "Users"
                                          ? _c("v-list-item-title", [
                                              _vm._v(_vm._s(_vm.$t("users")))
                                            ])
                                          : _vm._e(),
                                        _vm._v(" "),
                                        admin.text == "Plants"
                                          ? _c("v-list-item-title", [
                                              _vm._v(_vm._s(_vm.$t("plants")))
                                            ])
                                          : _vm._e(),
                                        _vm._v(" "),
                                        admin.text == "Plant Specific Data"
                                          ? _c("v-list-item-title", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("plantspecificdata")
                                                )
                                              )
                                            ])
                                          : _vm._e(),
                                        _vm._v(" "),
                                        admin.text == "Feedback"
                                          ? _c("v-list-item-title", [
                                              _vm._v(_vm._s(_vm.$t("feedback")))
                                            ])
                                          : _vm._e(),
                                        _vm._v(" "),
                                        admin.text == "Languages"
                                          ? _c("v-list-item-title", [
                                              _vm._v(
                                                _vm._s(_vm.$t("languages"))
                                              )
                                            ])
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c(
                                          "v-list-item-icon",
                                          [
                                            _c("v-icon", [
                                              _vm._v(_vm._s(admin.icon))
                                            ])
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  })
                                ],
                                2
                              )
                            ],
                            2
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-app-bar",
                    { attrs: { app: "", color: "primary", dark: "" } },
                    [
                      _c("v-app-bar-nav-icon", {
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            _vm.drawer = !_vm.drawer
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("v-toolbar-title", [_vm._v(_vm._s(_vm.$t("title")))]),
                      _vm._v(" "),
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c("v-spacer", [
                        _c(
                          "div",
                          { staticStyle: { "text-align": "right" } },
                          [
                            _c(
                              "v-tooltip",
                              {
                                attrs: { bottom: "" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function(ref) {
                                        var on = ref.on
                                        var attrs = ref.attrs
                                        return [
                                          _c(
                                            "v-icon",
                                            _vm._g(
                                              _vm._b(
                                                {
                                                  directives: [
                                                    {
                                                      name: "show",
                                                      rawName: "v-show",
                                                      value:
                                                        _vm.isLoggedInUserActive &&
                                                        _vm.isNonLYBUser,
                                                      expression:
                                                        "isLoggedInUserActive && isNonLYBUser"
                                                    }
                                                  ],
                                                  attrs: { dark: "" },
                                                  on: {
                                                    click: function($event) {
                                                      $event.stopPropagation()
                                                      _vm.fbdialog = true
                                                    }
                                                  }
                                                },
                                                "v-icon",
                                                attrs,
                                                false
                                              ),
                                              on
                                            ),
                                            [_vm._v("feedback")]
                                          ),
                                          _vm._v(" "),
                                          _vm._v(
                                            "\n                                  \n                                "
                                          ),
                                          _c(
                                            "v-dialog",
                                            {
                                              attrs: { "max-width": "70%" },
                                              model: {
                                                value: _vm.fbdialog,
                                                callback: function($$v) {
                                                  _vm.fbdialog = $$v
                                                },
                                                expression: "fbdialog"
                                              }
                                            },
                                            [
                                              _c(
                                                "v-card",
                                                [
                                                  _c(
                                                    "v-card-title",
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "headline"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t("feedback")
                                                            )
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c("v-spacer"),
                                                      _vm._v(" "),
                                                      _c(
                                                        "v-icon",
                                                        {
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              _vm.fbdialog = false
                                                              _vm.$toast.clear()
                                                            }
                                                          }
                                                        },
                                                        [_vm._v("close")]
                                                      )
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-card-text",
                                                    [
                                                      _c(
                                                        "v-container",
                                                        [
                                                          _c("v-textarea", {
                                                            attrs: {
                                                              outlined: "",
                                                              label: _vm.$t(
                                                                "feedback"
                                                              )
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.feedbackItem
                                                                  .comments,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.$set(
                                                                  _vm.feedbackItem,
                                                                  "comments",
                                                                  $$v
                                                                )
                                                              },
                                                              expression:
                                                                "feedbackItem.comments"
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-card-actions",
                                                    [
                                                      _c(
                                                        "v-btn",
                                                        {
                                                          attrs: {
                                                            color:
                                                              "blue darken-1",
                                                            text: ""
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              _vm.fbdialog = false
                                                              _vm.$toast.clear()
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t("cancel")
                                                            )
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c("v-spacer"),
                                                      _vm._v(" "),
                                                      _c(
                                                        "v-btn",
                                                        {
                                                          staticClass: "mb-2",
                                                          attrs: {
                                                            color: "primary",
                                                            dark: ""
                                                          },
                                                          on: {
                                                            click: _vm.fbsave
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t("save")
                                                            )
                                                          )
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  2724560327
                                )
                              },
                              [_vm._v(" "), _c("span", [_vm._v("Feedback")])]
                            ),
                            _vm._v(" "),
                            _c(
                              "v-btn",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.isLoggedInUserActive,
                                    expression: "isLoggedInUserActive"
                                  }
                                ],
                                attrs: { icon: "", color: "white" },
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                    return _vm.openUserPreference()
                                  }
                                }
                              },
                              [_c("v-icon", [_vm._v("settings")])],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-dialog",
                              {
                                attrs: { persistent: "", "max-width": "600px" },
                                model: {
                                  value: _vm.dialog,
                                  callback: function($$v) {
                                    _vm.dialog = $$v
                                  },
                                  expression: "dialog"
                                }
                              },
                              [
                                _c(
                                  "v-card",
                                  [
                                    _c(
                                      "v-card-title",
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "headline" },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("userprofile"))
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("v-spacer"),
                                        _vm._v(" "),
                                        _c(
                                          "v-icon",
                                          {
                                            on: {
                                              click: function($event) {
                                                _vm.dialog = false
                                              }
                                            }
                                          },
                                          [_vm._v("close")]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-card-text",
                                      [
                                        _c(
                                          "v-container",
                                          [
                                            _c(
                                              "v-row",
                                              [
                                                _c(
                                                  "v-col",
                                                  {
                                                    attrs: {
                                                      cols: "12",
                                                      sm: "8",
                                                      md: "8"
                                                    }
                                                  },
                                                  [
                                                    _c("v-select", {
                                                      attrs: {
                                                        items: _vm.languages,
                                                        label: _vm.$t(
                                                          "selectlanguage"
                                                        ),
                                                        "item-text": "language",
                                                        "item-value": "id",
                                                        required: ""
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.selectedlanguage,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.selectedlanguage = $$v
                                                        },
                                                        expression:
                                                          "selectedlanguage"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-row",
                                              [
                                                _c(
                                                  "v-col",
                                                  {
                                                    attrs: {
                                                      cols: "12",
                                                      sm: "8",
                                                      md: "8"
                                                    }
                                                  },
                                                  [
                                                    _c("v-select", {
                                                      attrs: {
                                                        items:
                                                          _vm.itemsddlDateFormat,
                                                        label: _vm.$t(
                                                          "selectdateformat"
                                                        ),
                                                        "item-text":
                                                          "DateFormat",
                                                        required: ""
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.selectedDateFormat,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.selectedDateFormat = $$v
                                                        },
                                                        expression:
                                                          "selectedDateFormat"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-row",
                                              [
                                                _c(
                                                  "v-col",
                                                  {
                                                    attrs: {
                                                      cols: "12",
                                                      sm: "8",
                                                      md: "8"
                                                    }
                                                  },
                                                  [
                                                    _c("v-select", {
                                                      attrs: {
                                                        items:
                                                          _vm.itemsRowsPerPage,
                                                        label: _vm.$t(
                                                          "rowsperpage"
                                                        ),
                                                        required: ""
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.selectedRowsPerPage,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.selectedRowsPerPage = $$v
                                                        },
                                                        expression:
                                                          "selectedRowsPerPage"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-row",
                                              {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value:
                                                      _vm.isLoggedInUserActive &&
                                                      _vm.isNonLYBUser &&
                                                      _vm.isUserInOnePlant,
                                                    expression:
                                                      "\n                      isLoggedInUserActive && isNonLYBUser && isUserInOnePlant\n                    "
                                                  }
                                                ]
                                              },
                                              [
                                                _c(
                                                  "v-col",
                                                  {
                                                    attrs: {
                                                      cols: "12",
                                                      sm: "8",
                                                      md: "8"
                                                    }
                                                  },
                                                  [
                                                    _c("v-select", {
                                                      attrs: {
                                                        items:
                                                          _vm.allRelatedMGs,
                                                        label:
                                                          "Select Maintenance Group",
                                                        "item-text": "value",
                                                        "item-value": "id"
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.selectedMaintenanceGroup,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.selectedMaintenanceGroup = $$v
                                                        },
                                                        expression:
                                                          "selectedMaintenanceGroup"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-card-actions",
                                      [
                                        _c(
                                          "v-btn",
                                          {
                                            attrs: {
                                              color: "blue darken-1",
                                              text: ""
                                            },
                                            on: {
                                              click: function($event) {
                                                _vm.dialog = false
                                              }
                                            }
                                          },
                                          [_vm._v(_vm._s(_vm.$t("close")))]
                                        ),
                                        _vm._v(" "),
                                        _c("v-spacer"),
                                        _vm._v(" "),
                                        _c("v-spacer"),
                                        _vm._v(" "),
                                        _c(
                                          "v-btn",
                                          {
                                            attrs: { color: "primary" },
                                            on: { click: _vm.saveProfile }
                                          },
                                          [_vm._v(_vm._s(_vm.$t("save")))]
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-main",
                    [
                      _c(
                        "v-container",
                        { attrs: { fluid: "" } },
                        [
                          _c(
                            "v-row",
                            { attrs: { align: "start", justify: "center" } },
                            [
                              _c(
                                "v-col",
                                { staticClass: "text-center" },
                                [_c("router-view")],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("v-footer", { attrs: { color: "primary", app: "" } }, [
                    _c("span", { staticClass: "white--text" }, [
                      _vm._v("© " + _vm._s(new Date().getFullYear()))
                    ])
                  ])
                ],
                1
              )
            : _c("div", [
                _c(
                  "div",
                  { staticClass: "center-screen" },
                  [
                    _c("v-progress-circular", {
                      attrs: {
                        size: 70,
                        width: 7,
                        color: "purple",
                        indeterminate: ""
                      }
                    })
                  ],
                  1
                )
              ])
        ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ba5bd90", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ba5bd90","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 